const items = [
  {
    type: {
      name: 'New Features',
      bg: 'blue100',
      color: 'blue700',
    },
    title: `We're deploying new digital teaching tools every week`,
    description:
      'Learn about all our feature enhancements and new digital tools by following our Feature Releases & Platform Updates page.',
    link: 'https://ellii.com/blog/feature-releases-platform-updates-2023',
  },
  {
    type: {
      name: 'New Content',
      bg: 'green50',
      color: 'green900',
    },
    title: `Have you seen all the new materials we've added recently?`,
    description: `Check out our What's New This Year page to see a list of all the new lessons, flashcards, and resources added to the site since you've last logged in.`,
    link: 'https://ellii.com/collections/new-content',
  },
]

export default items
